export default "__VITE_ASSET__Ce8qiXAp__"